import { useMutation, useQueryClient } from "@tanstack/react-query";
import { enableCapital } from "../../../services/accountService";

export default function useEnableCapitalMutation() {
  const queryClient = useQueryClient();
  return useMutation<string, Error, string>(
    (accountHolderCode: string) => enableCapital(accountHolderCode),
    {
      onSuccess(_, accountHolderCode) {
        queryClient.invalidateQueries(["accountConfig", accountHolderCode]);
      },
    }
  );
}
